export default __webpack_public_path__ + "images/breast-cancer/country.png";